export class Teilnehmer {
  guid: string;
  name: string;
  email: string;
  tel: string;
  unternehmenGuid: string;
  umfrageGuid: string;
  umfragedauer: number;
  themenUmfrage: boolean;
  bewertungUmfrage: boolean;
  isDeleted: number;

  constructor() {
    this.guid = '';
    this.name = '';
    this.email = '';
    this.tel = '';
    this.unternehmenGuid = '';
    this.umfrageGuid = '';
    this.umfragedauer = 0;
    this.themenUmfrage = false;
    this.bewertungUmfrage = false;
    this.isDeleted = 0;
  }
}

export class TeilnehmerEmail {
  guid: string;
  subject: string;
  message: string;

  constructor() {
    this.guid = '';
    this.subject = '';
    this.message = '';
  }
}
